
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { closeAllModal, setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";
import { toast } from "react-toastify";
import { toastApiError } from "../../helper/api/toastApiError";

const initialState = {
  adminUyeler: [],
  isLoadingGetAdminUyeler: false,
  adminUyelerCount: 0,
  uyeSurucuList: [],
  uyeSurucuListCount: 0,
  responseMessageList: [],
  singleUyeAracList: [],
  singleUyeCalismaSekliYerleri: [],
  isLoadingAddAdminUye: false,
  isLoadingAdminAddTopluUye: false,
  isLoadingUpdateAdminUye: false,
  isLoadingGetTopluUyeExcel: false,
  uyeItemData: null,

  isLoadingAdminUyeSurucuEkle: false,
  isLoadingAdminGetUyeAraclarByUserId: false,
  isLoadingGetAdminUyeCalismaSekliYerleri: false,
  userPhoneNumberUniqueResData: null,
  isLoadingGetUserPhoneNumberUnique: false,
  userTcNoUniqueResData:null,
  isLoadingGetUserTcNoUnique: false,
  isLoadingUpdateUyeDoc: false,
  isSuccessUyeDoc: false,

  userTCApprovedResData: null,
  isLoadingGetUserTcApprove: false,



  adminAraclar: [],
  adminAraclarCount:null,
  selectAdminArac: null,
  adminTruckDocs: null,
  adminTrailerDocs: null,

  cezaBilgi: null,
  yetkiBelgesiBilgi: null,
  muayeneBilgi: null,
  aracMuayeneExcel: null,

  topluAracEklemeHatalar:[],


  isLoadingAddAdminTruckSingle: false,
  isLoadingGetAllTruckAndTrailer: false,
  isLoadingAdminAracCezaSorgula: false,
  isLoadingAdminAracYetkiBelgesiSorgula: false,
  isLoadingAdminAracMuayeneSorgula: false,
  isLoadingMuayeneExcel: false,
  isLoadingDorseCezaExcel: false,
  isLoadingDorseMuayeneExcel: false,
  isLoadingAraclarExcel:false,
  isLoadingAdminAracUpdate:false,
  isLoadingAdminTopluAracEkle:false,
  isLoadingAdminAracSilme:false,
  
  isLoadingGetDoc: false,

  
  //! web sayfası
  webHesaplamaSonuclari: null,
  webHesaplamaSonuclariCount: null,
  isLoadingWebSonuclari:null,
  //! web sayfası



  isLoadingAdminUpdateDocumentTruck: false,
  isLoadingAdminUpdateDocumentTrailer: false,

};



export const addAdminUye = createAsyncThunk("admin2/addAdminUye",async (newUye, thunkApi) => {
    try {
      const { data } = await axiosInstance.post( `/Auth/AddUserFromClient`, newUye);
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Üye ekleme işlemi başarı ile gerçekleştirildi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
      }

      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({msg:error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin",  resultType: "error",  btnText1: "Listeyi Görüntüle",})
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const adminAddTopluUye = createAsyncThunk("admin2/adminAddTopluUye",async (excel, thunkApi) => {
    try {
      
      const file = new FormData();
      file.append("file", excel);
      const { data } = await axiosInstance.post( `/Auth/AddUserFromClientToplu`, file);
      if (data.statusCode === 200 && data.data.$values.filter(item => !item.isAdded).length === 0) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Toplu üye ekleme işlemi başarı ile gerçekleştirildi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
      }
      if(data.statusCode === 200 && data.data.$values.filter(item => !item.isAdded).length > 0){
        thunkApi.dispatch(setTopluUyeEkleMessageList(data.data.$values.filter(item => !item.isAdded)))
      }
      return data;
    } catch (error) {
      thunkApi.dispatch(setResultModalData({ msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin",  resultType: "error",  btnText1: "Listeyi Görüntüle",}));
      return thunkApi.rejectWithValue(error);
    }
  }
);



export const updateAdminUye = createAsyncThunk("admin2/updateAdminUye", async (updatedData, thunkApi) => {
  try {
    const { data } = await axiosInstance.post(`/user/UpdateUye`, updatedData);
    if (data.statusCode === 200 && data.data) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Üye güncelleme işlemi başarıyla gerçekleştirildi", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    if(!data.data){
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({msg: data.message || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(
      setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",btnText1: "Listeyi Görüntüle",})
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

//! sürücülü adam 5305122361
//! admin araclar update araç
export const getAdminUyeSuruculeri = createAsyncThunk("admin2/getAdminUyeSuruculeri", async({userId, page}, thunkApi) => {
  try {
  
    const { data } = await axiosInstance.get(`/user/KullanicininSuruculeriniGor?userId=${userId}&page=${page}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})
  
export const adminUyeSurucuEkle = createAsyncThunk("admin2/adminUyeSurucuEkle", async(uyeSurucu, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.post(`/user/KullaniciyaSurucuEkle`, uyeSurucu);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Sürücü ekleme işlemi başarıyla gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})



export const adminDeleteUyeSurucu = createAsyncThunk("admin2/adminDeleteUyeSurucu", async({uyeId, driverId}, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.post(`/user/DeleteUserDriver`, {uyeId, driverId});
    if (data.statusCode === 200) {
      thunkApi.dispatch(showNestedModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Sürücü silme işlemi başarıyla gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})


export const adminGetUyeAraclarByUserId = createAsyncThunk("admin2/adminGetUyeAraclarByUserId", async(userId, thunkApi) => {
  try {
   
    const { data } = await axiosInstance.get(`/User/GetTruckAndTrailerForWebFromUserId?userId=${userId}`);
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})
 

export const getAdminUyeCalismaSekliYerleri = createAsyncThunk("admin2/getAdminUyeCalismaSekliYerleri",async (id, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/User/PiyasaBilgisiGetirById?id=${id}`);
      return data;
    } catch (error) {
      //! burada hata verse bile aşagıdaki modal a yönlendir.
      // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin" ,resultType: "error", btnText1: "Listeye Dön"}))
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateAdminUyeCalismaSekliYerleri = createAsyncThunk("admin2/updateAdminUyeCalismaSekliYerleri",async ({phoneNumber, item}, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.post(`/User/PisayaBilgisiEkleByWeb?phoneNumberPiyasaBilgisiEklenecek=${phoneNumber}`, item);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Üye Güncelleme işlemi başarıyla gerçekleştirildi", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    //! burada hata verse bile aşagıdaki modal a yönlendir.
    // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin" ,resultType: "error", btnText1: "Listeye Dön"}))
    return thunkApi.rejectWithValue(error);
  }
}
);


export const getTopluUyeExcel = createAsyncThunk("admin2/getTopluUyeExcel", async(_, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.get(`/user/GetUsersFromDatabaseToExcel`)

      const link = document.createElement('a');
      link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
      document.body.appendChild(link)
      link.click();
      document.body.removeChild(link)
      return data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})


export const getUserPhoneNumberUnique = createAsyncThunk("admin2/getUserPhoneNumberUnique", async(phoneNumber, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.get(`/User/UserPhoneNumberUnique?phoneNumber=${phoneNumber}`)
      if (data.statusCode === 200 && !data.data.isTherePhoneNumber) {
        thunkApi.dispatch(showNestedModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bu telefon numarasına ait bir kullanıcı bulunmamaktadır.", resultType: "success", btnText1: "Tamam",}));
      }
      if (data.statusCode === 200 && data.data.isTherePhoneNumber) {
        thunkApi.dispatch(showNestedModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bu telefon numarasına ait bir kullanıcı bulunmaktadır.", resultType: "error", btnText1: "Tamam",}));
      }
      return {
        res: data.data.isTherePhoneNumber,
        checkedPhoneNumber: phoneNumber
      }
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})

export const getUserTcNoUnique = createAsyncThunk("admin2/getUserTcNoUnique", async(tcNo, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.get(`/User/UserTcNoNumberUniqueQuery?tcNo=${tcNo}`)
      
      // if (data.statusCode === 200 && !data.data.isTherePhoneNumber) {
      //   thunkApi.dispatch(showNestedModal("result"));
      //   thunkApi.dispatch(setResultModalData({ msg: "Bu telefon numarasına ait bir kullanıcı bulunmamaktadır.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
      // }
      if (data.statusCode === 200 && data.data.isTherePhoneNumber) {
        thunkApi.dispatch(showNestedModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bu telefon numarasına ait bir kullanıcı bulunmaktadır.", resultType: "error", btnText1: "Listeyi Görüntüle",}));
      }
      return {
        res: data.data.isTherePhoneNumber,
        checkedTcNo: tcNo
      }
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})

export const getUserTcApprove = createAsyncThunk("admin2/getUserTcApprove", async(approveData, thunkApi)=> {
  try {
    

      const {data} = await axiosInstance.post(`/User/UserTcApprove`, {...approveData, dogumTarihi: approveData.dogumTarihi.split("-")[0]})
      
      return {
        res: data.data.userTcApprove,
        id: data.data.user.id,
        ...approveData
      }
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})





//! FFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFKFFK

//! tekli araç ekleme
export const addAdminTruckSingle = createAsyncThunk("admin/addAdminTruckSingle", async (param, thunkApi) => {
  try {
    const { data } = await axiosInstance.post( `/truckTrailer/AddTruckTrailerFromClientTekli`, param);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    else {
      const message = toastApiError(data, "Araç eklenemedi.");
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: message, resultType: "error", btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    const message = toastApiError(error, "Araç eklenemedi.");
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ msg: message, resultType: "error", btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue({ message });
  }
}
);

//! muayene sorgula
export const adminAracMuayeneExcel = createAsyncThunk("admin2/adminAracMuayeneExcel",async (_, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/KamyonVeyaCekiciMuayeneGetirExcel`);

    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

//! dorse toplu muayene sorgula
export const adminDorseCezaExcel = createAsyncThunk("admin2/adminDorseCezaExcel",async (_, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/DorseCezalarınıGetirExcel`);
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)

    link.click();
    document.body.removeChild(link)


    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

//! dorse toplu muayene sorgula
export const adminDorseMuayeneExcel = createAsyncThunk("admin2/adminDorseMuayeneExcel",async (_, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/DorseMuayeneleriniGetirExcel`);
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)

    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);


//! admin araçalr get excel
export const getAdminAraclarToExcel = createAsyncThunk("admin2/getAdminAraclarToExcel", async (_, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/TruckTrailer/GetTruckAndTrailerToExcel`);
    
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)

    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
    return thunkApi.rejectWithValue(error);
  }
});


//! admin araclar update araç
export const adminAraclarAracUpdate = createAsyncThunk("admin2/adminAraclarAracUpdate", async(body, thunkApi) => {
  try {

    const { data } = await axiosInstance.post(`/TruckTrailer/UpdateTasit`, body);

    if(data.statusCode === 200){
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç güncelleme işlemi başarıyla gerçekleştirildi", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    else{
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
    }
    return data.data;
  } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: error.response.data.ErrorDto.Errors[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
      return thunkApi.rejectWithValue(error);
  }
})


//! admin araclar toplu araç ekle
export const adminAraclarTopluAracEkle = createAsyncThunk("admin2/adminAraclarTopluAracEkle", async(excel, thunkApi) => {
  try {

    const file = new FormData();
    file.append("file", excel);

    const { data } = await axiosInstance.post(`/truckTrailer/AddTruckTrailerFromClientToplu`, file);

    if (data.statusCode === 200 && data?.data?.$values.filter(item => !item.isAdded).length === 0) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    if (data.statusCode === 200 && data?.data?.$values.filter(item => !item.isAdded).length > 0) {
      thunkApi.dispatch(setTopluAracEklemeHatalar(data?.data?.$values.filter(item => !item.isAdded)))
    }
    
    return data.data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
    return thunkApi.rejectWithValue(error);
  }
})


//! admin araçlar araç silme
export const adminAraclarAracSilme = createAsyncThunk("admin2/adminAraclarAracSilme", async(query, thunkApi) => {
  try {
   
    const { data } = await axiosInstance.post(`/TruckTrailer/DeleteTruckOrTrailerPlate?PlateNumber=${query}`, "_");
    if(data.statusCode === 200){
      thunkApi.dispatch(closeAllModal())
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç silme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    return data.data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
  }})





//! arac belge get
export const adminGetTruckDoc = createAsyncThunk("admin2/adminGetTruckDoc", async (plaka, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/TruckTrailer/GetTruckByPlateNumber?plaka=${plaka}`);
      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg:
            error.response.data.error.errors.$values[0] ||
            "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
          resultType: "error",
          btnText1: "Listeye Dön",
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);
//! dorse belge get
export const adminGetTrailerDoc = createAsyncThunk("admin2/adminGetTrailerDoc", async (plaka, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/TruckTrailer/GetTrailerByPlateNumber?plaka=${plaka}`);
      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg:
            error.response.data.error.errors.$values[0] ||
            "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
          resultType: "error",
          btnText1: "Listeye Dön",
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

//! Web Sayfası maliyet hesaplama sonuçları
export const getWebHesaplama = createAsyncThunk("admin2/getWebHesaplama", async (page, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/MaliyetHesabi/GetAllMaliyetHesabiCalculate?Page=${page}`);
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});



//! ****************************************************************************************************************************************************


//! getAdminUyeler
export const getAdminUyeler = createAsyncThunk("admin2/getAdminUyeler",async ({ currentPage, adSoyadUnvan, IlIlce = "", tcNo, phoneNumber, appVersionType, itemsPerPage},thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/user/SuruculeriGetir10?sayfaSayisi=${currentPage}&&AdSoyadUnvan=${adSoyadUnvan}&&IlceIl=${IlIlce}&&tcNo=${tcNo}&&phoneNumber=${phoneNumber}&&AppVersion=${appVersionType}&&pageSize=${itemsPerPage}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);


//! adminUpdateUyeDoc
export const adminUpdateUyeDoc = createAsyncThunk("admin2/adminUpdateUyeDoc", async(updatedUyeDoc, thunkApi) => {
  try {
    const file = new FormData();
    file.append("UserName", updatedUyeDoc.userName);
    file.append("DocumentType", updatedUyeDoc.documentType);
    file.append("FormFile", updatedUyeDoc.imageFile);

    const { data } = await axiosInstance.post(`/User/UploadDocToUser`, file);
 
    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})


//! get admin araçlar
export const getAllTruckAndTrailer = createAsyncThunk("admin2/getAllTruckAndTrailer",async ({ currentPage, plaka, phoneNumber, aktifPasif, adSoyadUnvan },thunkApi) => {
  try {
    

    const { data } = await axiosInstance.get(`/TruckTrailer/GetAllTruckAndTrailer?Plaka=${plaka?.trim()}&CurrentPage=${currentPage}&PhoneNumber=${phoneNumber?.trim()}&AktifPasif=${aktifPasif?.trim()}&AdSoyadUnvan=${adSoyadUnvan?.trim()}`);
      
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

//! adminUpdateDocumentTruck
export const adminUpdateDocumentTruck = createAsyncThunk("admin2/adminUpdateDocumentTruck",async (updatedTruckDoc, thunkApi) => {
  try {

    const file = new FormData();
    file.append("PlateNumber", updatedTruckDoc.plateNumber);
    file.append("DocumentType", updatedTruckDoc.documentType);
    file.append("FormFile", updatedTruckDoc.imageFile);

    const { data } = await axiosInstance.post(`/TruckTrailer/UploadDocToTruck`, file);

    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);


//! adminUpdateDocumentTrailer
export const adminUpdateDocumentTrailer = createAsyncThunk("admin2/adminUpdateDocumentTrailer", async (updatedTrailerDoc, thunkApi) => {
  try {
    const file = new FormData();
    file.append("PlateNumber", updatedTrailerDoc.plateNumber);
    file.append("DocumentType", updatedTrailerDoc.documentType);
    file.append("FormFile", updatedTrailerDoc.imageFile);

    const { data } = await axiosInstance.post(`/TruckTrailer/UploadPhotoToTrailer`, file);
    return data.data;
  } catch (error) {
    console.log(error);
    return thunkApi.rejectWithValue(error);
  }
}
);




//! adminAracCezaSorgula
export const adminAracCezaSorgula = createAsyncThunk("admin2/adminAracCezaSorgula", async (plaka, thunkApi) => {
  try {   

    const { data } = await axiosInstance.get(`/TruckTrailer/CezaSorgula?Plaka=${plaka}`);
    
    // if (data.statusCode === 200) {
    //   thunkApi.dispatch(showModal("adminAraclarCezaSorgulaModal"));
    // }

    return data;
  } catch (error) {
    // thunkApi.dispatch(showModal("result"));
    // thunkApi.dispatch(setResultModalData({ msg: error?.response?.data?.error?.errors?.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue(error);
  }
}
);

//! adminAracYetkiBelgesiSorgula
export const adminAracYetkiBelgesiSorgula = createAsyncThunk("admin2/adminAracYetkiBelgesiSorgula", async (plaka, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/AracYetkiBelgesiSorgula?Plaka=${plaka}`);
    // if (data.statusCode === 200) {
    //   thunkApi.dispatch(showModal("adminAraclarYetkiBelgesiModal"));
    // }

    return data;
  } catch (error) {
    // thunkApi.dispatch(showModal("result"));
    // thunkApi.dispatch(setResultModalData({ msg: error?.response?.data?.error?.errors?.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue(error);
  }
}
);

//! adminAracMuayeneSorgula
export const adminAracMuayeneSorgula = createAsyncThunk("admin2/adminAracMuayeneSorgula",async (plaka, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/AracMuayeneSorgula?Plaka=${plaka}`);
    // if (data.statusCode === 200) {
    //   thunkApi.dispatch(showModal("adminAraclarMuayeneModal"));
    // }

    return data;
  } catch (error) {
    // thunkApi.dispatch(showModal("result"));
    // thunkApi.dispatch(setResultModalData({ msg: error?.response?.data?.error?.errors?.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue(error);
  }
}
);


//! removeAdminUserDocItem
export const removeAdminUserDocItem = createAsyncThunk("admin2/removeAdminUserDocItem",async (body, thunkApi) => {
  try {

    
    const { data } = await axiosInstance.post(`/User/RemoveUserDocumentByAdmin`, body);

    if(data.statusCode === 200){
      toast.success(`Araç Belgesi başarıyla Silindi.`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
  }
  else{
      toast.error(`Bir Hata Meydana Geldi..`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
  }

    return {message: data.message, id: body.userId};
  } catch (error) {
    console.log(error);
    toast.error(`Bir Hata Meydana Geldi..`, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
  });
    return thunkApi.rejectWithValue(error);
  }
}
);

//! removeAdminTruckDocItem
export const removeAdminTruckDocItem = createAsyncThunk("admin2/removeAdminTruckDocItem",async (body, thunkApi) => {
  try {

    const { data } = await axiosInstance.post(`/TruckTrailer/RemoveTruckDocumentByAdmin`, body);

      if(data.statusCode === 200){
        toast.success(`Araç Belgesi başarıyla Silindi.`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
    else{
        toast.error(`Bir Hata Meydana Geldi..`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    return {message: data.message, id: body.truckId};
  } catch (error) {
      console.log(error);
      toast.error(`Bir Hata Meydana Geldi..`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    return thunkApi.rejectWithValue(error);
  }
}
);


//! removeAdminTrailerDocItem
export const removeAdminTrailerDocItem = createAsyncThunk("admin2/removeAdminTrailerDocItem",async (body, thunkApi) => {
  try {

    const { data } = await axiosInstance.post(`/TruckTrailer/RemoveTrailerDocumentByAdmin`, body);
    if(data.statusCode === 200){
      toast.success(`Römork Belgesi başarıyla Silindi.`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
  }
  else{
      toast.error(`Bir Hata Meydana Geldi..`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
  }

  return {message: data.message, id: body.trailerId};
} catch (error) {
    console.log(error);
    toast.error(`Bir Hata Meydana Geldi..`, {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  return thunkApi.rejectWithValue(error);
}
}
);



const admin2Slice = createSlice({
  name: "admin2",
  initialState,
  reducers: {
    getUyeItemData: (state, action) => {
      state.uyeItemData = action.payload;
    },

    setSelectAdminArac: (state, action) => {
      state.selectAdminArac = action.payload;
    },

    setTopluUyeEkleMessageList: (state, action) => {
      state.responseMessageList = action.payload
    },

    setTopluAracEklemeHatalar: (state, action) => {
      state.topluAracEklemeHatalar = action.payload
    },

    clearTopluUyeEkleMessageList: (state, action) => {
      state.responseMessageList = []
    }
  },
  extraReducers: (builder) => {
    builder



    //! addAdminUye
    .addCase(addAdminUye.pending, (state) => {
      state.isLoadingAddAdminUye = true;
    })
    .addCase(addAdminUye.fulfilled, (state, action) => {
      state.isLoadingAddAdminUye = false;
      const {srcTypes, ehliyetTypes } = action.payload.data
      const newData = {...action.payload.data, srcTypes: srcTypes.$values, ehliyetTypes: ehliyetTypes.$values }
      state.adminUyeler = [...state.adminUyeler, newData];
      state.adminUyelerCount = state.adminUyelerCount + 1;
    })
    .addCase(addAdminUye.rejected, (state, action) => {
      state.isLoadingAddAdminUye = false;
    })

    //! adminAddTopluUye
    .addCase(adminAddTopluUye.pending, (state) => {
      state.isLoadingAdminAddTopluUye = true;
    })
    .addCase(adminAddTopluUye.fulfilled, (state, action) => {
      state.isLoadingAdminAddTopluUye = false;
      const newAddedList = action.payload.data.$values.filter(item => item.isAdded).map(item => item.items) 
      state.adminUyeler = [...state.adminUyeler, ...newAddedList]
    })
    .addCase(adminAddTopluUye.rejected, (state, action) => {
      state.isLoadingAdminAddTopluUye = false;
    })

//! adminAddTopluUye
    .addCase(adminUyeSurucuEkle.pending, (state) => {
      state.isLoadingAdminUyeSurucuEkle = true;

    })
    .addCase(adminUyeSurucuEkle.fulfilled, (state, action) => {
      state.isLoadingAdminUyeSurucuEkle = false;
    })
    .addCase(adminUyeSurucuEkle.rejected, (state, action) => {
      state.isLoadingAdminUyeSurucuEkle = false;
    })

    //! admin üye güncelleme
     .addCase(updateAdminUye.pending, (state) => {
      state.isLoadingUpdateAdminUye = true
    })
    .addCase(updateAdminUye.fulfilled, (state, action)=> {
      state.isLoadingUpdateAdminUye = false
      const {data} = action.payload
      state.adminUyeler = state.adminUyeler.map((item) => {
        if(item.id === data.id){
          return {
            ...data,
            ehliyetTypes: data.ehliyetTypes.$values,
            srcTypes: data.srcTypes.$values,
          }
        }
        else{
          return item
        }
      })
    })
    .addCase(updateAdminUye.rejected, (state, action)=> {
        state.isLoadingUpdateAdminUye = false
    })

    //! get uyenin suruculeri
    .addCase(getAdminUyeSuruculeri.pending, (state) => {
      // state.isLoadingUpdateAdminUye = true
      state.uyeSurucuList = []
    })
    .addCase(getAdminUyeSuruculeri.fulfilled, (state, action)=> {
      // state.isLoadingUpdateAdminUye = false
      state.uyeSurucuList = action.payload.data.musteriListesi.$values
      state.uyeSurucuListCount = action.payload.data.count
    })
    .addCase(getAdminUyeSuruculeri.rejected, (state, action)=> {
        // state.isLoadingUpdateAdminUye = false
    })



    //! adminDeleteUyeSurucu
    .addCase(adminDeleteUyeSurucu.pending, (state) => {
      // state.isLoadingUpdateAdminUye = true
    })
    .addCase(adminDeleteUyeSurucu.fulfilled, (state, action)=> {
      // state.isLoadingUpdateAdminUye = false
      state.uyeSurucuList = state.uyeSurucuList.filter(item => item.id !== action.payload.data.driverId) 
    })
    .addCase(adminDeleteUyeSurucu.rejected, (state, action)=> {
        // state.isLoadingUpdateAdminUye = false
    })

    //! get toplu uye excel
    .addCase(getTopluUyeExcel.pending, (state) => {
      state.isLoadingGetTopluUyeExcel = true
    })
    .addCase(getTopluUyeExcel.fulfilled, (state, action)=> {
      state.isLoadingGetTopluUyeExcel = false
    })
    .addCase(getTopluUyeExcel.rejected, (state, action)=> {
        state.isLoadingGetTopluUyeExcel = false
    })

    //! adminGetUyeAraclarByUserId
    .addCase(adminGetUyeAraclarByUserId.pending, (state) => {
      state.isLoadingAdminGetUyeAraclarByUserId = true
    })
    .addCase(adminGetUyeAraclarByUserId.fulfilled, (state, action) => {
      state.isLoadingAdminGetUyeAraclarByUserId = false
      state.singleUyeAracList = action.payload.data.$values

    })
    .addCase(adminGetUyeAraclarByUserId.rejected, (state) => {
      state.isLoadingAdminGetUyeAraclarByUserId = false
    })

    //! getAdminUyeCalismaSekliYerleri
    .addCase(getAdminUyeCalismaSekliYerleri.pending, (state) => {
      state.isLoadingGetAdminUyeCalismaSekliYerleri = true
    })
    .addCase(getAdminUyeCalismaSekliYerleri.fulfilled, (state, action) => {
      state.isLoadingGetAdminUyeCalismaSekliYerleri = false
      state.singleUyeCalismaSekliYerleri = action.payload.data
    })
    .addCase(getAdminUyeCalismaSekliYerleri.rejected, (state) => {
      state.isLoadingGetAdminUyeCalismaSekliYerleri = false
    })

    //! getUserPhoneNumberUnique
    .addCase(getUserPhoneNumberUnique.pending, (state) => {
      state.isLoadingGetUserPhoneNumberUnique = true
    })
    .addCase(getUserPhoneNumberUnique.fulfilled, (state, action) => {
      state.isLoadingGetUserPhoneNumberUnique = false
      state.userPhoneNumberUniqueResData = action.payload
    })
    .addCase(getUserPhoneNumberUnique.rejected, (state) => {
      state.isLoadingGetUserPhoneNumberUnique = false
    })


    //! getUserTcNoUnique
    .addCase(getUserTcNoUnique.pending, (state) => {
      state.isLoadingGetUserTcNoUnique = true
    })
    .addCase(getUserTcNoUnique.fulfilled, (state, action) => {
      state.isLoadingGetUserTcNoUnique = false
      state.userTcNoUniqueResData = action.payload
    })
    .addCase(getUserTcNoUnique.rejected, (state) => {
      state.isLoadingGetUserTcNoUnique = false
    })

    //! getUserTcApprove
    .addCase(getUserTcApprove.pending, (state) => {
      state.isLoadingGetUserTcApprove = true
    })
    .addCase(getUserTcApprove.fulfilled, (state, action) => {
      state.isLoadingGetUserTcApprove = false
      state.userTCApprovedResData = action.payload

      //! bu buulup modal da kullanılan item ı da güncellemnek için
      const updatedItem = state.adminUyeler.find(item => item.id === action.payload.id)
      state.uyeItemData = {...updatedItem, isTcNoValid: action.payload.res}
      state.adminUyeler = state.adminUyeler.map(item => {
        if(item.id === action.payload.id){
          return {...item, isTcNoValid: action.payload.res}
        }
        else{
          return item
        }
      })
    })
    .addCase(getUserTcApprove.rejected, (state) => {
      state.isLoadingGetUserTcApprove = false
    })
    
    

    


//! ffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffkffk

      //! tekli araç ekleme
      .addCase(addAdminTruckSingle.pending, (state) => {
        state.isLoadingAddAdminTruckSingle = true;
      })
      .addCase(addAdminTruckSingle.fulfilled, (state, action) => {
        state.isLoadingAddAdminTruckSingle = false;
        state.adminAraclar = [
          ...state.adminAraclar,
          action.payload.data.$values[0],
        ];
      })
      .addCase(addAdminTruckSingle.rejected, (state, action) => {
        state.isLoadingAddAdminTruckSingle = false;
      })

      //! muayene excel
      .addCase(adminAracMuayeneExcel.pending, (state) => {
        state.isLoadingMuayeneExcel = true;
      })
      .addCase(adminAracMuayeneExcel.fulfilled, (state, action) => {
        state.isLoadingMuayeneExcel = false;
        state.aracMuayeneExcel = action.payload;
      })
      .addCase(adminAracMuayeneExcel.rejected, (state) => {
        state.isLoadingMuayeneExcel = false;
      })

      //! ceza dorse excel
      .addCase(adminDorseCezaExcel.pending, (state) => {
        state.isLoadingDorseCezaExcel = true;
      })
      .addCase(adminDorseCezaExcel.fulfilled, (state,action) => {
        state.isLoadingDorseCezaExcel = false
      })
      .addCase(adminDorseCezaExcel.rejected, (state) => {
        state.isLoadingDorseCezaExcel = false;
      })

      //! ceza dorse excel
      .addCase(adminDorseMuayeneExcel.pending, (state) => {
        state.isLoadingDorseMuayeneExcel = true;
      })
      .addCase(adminDorseMuayeneExcel.fulfilled, (state,action) => {
        state.isLoadingDorseMuayeneExcel = false
      })
      .addCase(adminDorseMuayeneExcel.rejected, (state) => {
        state.isLoadingDorseMuayeneExcel = false;
      })

      //! araçlar get excel
      .addCase(getAdminAraclarToExcel.pending, (state) => {
        state.isLoadingDorseMuayeneExcel = true;
      })
      .addCase(getAdminAraclarToExcel.fulfilled, (state) => {
        state.isLoadingDorseMuayeneExcel = false;
      })
      .addCase(getAdminAraclarToExcel.rejected, (state) => {
        state.isLoadingDorseMuayeneExcel = false;
      })

      //! araçlar update
      .addCase(adminAraclarAracUpdate.pending, (state) => {
        state.isLoadingAdminAracUpdate = true;
      })
      .addCase(adminAraclarAracUpdate.fulfilled, (state, action) => {
        state.isLoadingAdminAracUpdate = false;
        state.adminAraclar = state.adminAraclar.map((item) => {
          if(item?.id === action.payload?.id){
            return {...item, ...action.payload, isBelgeActive: action.payload.aktifPasif === "aktif" ? true : false}
          }
          else{
            return item
          }
        })
      })
    
      .addCase(adminAraclarAracUpdate.rejected, (state) => {
        state.isLoadingAdminAracUpdate = false;
      })

      //! araçlar post excel
      .addCase(adminAraclarTopluAracEkle.pending, (state) => {
        state.isLoadingAdminTopluAracEkle = true;
      })
      .addCase(adminAraclarTopluAracEkle.fulfilled, (state, action) => {
        state.isLoadingAdminTopluAracEkle = false;
        state.adminAraclar = [...state.adminAraclar, ...action.payload.$values]
      })
      .addCase(adminAraclarTopluAracEkle.rejected, (state) => {
        state.isLoadingAdminTopluAracEkle = false;
      })

      //! araçlar plaka silme
      .addCase(adminAraclarAracSilme.pending, (state) => {
        state.isLoadingAdminAracSilme = true;
      })
      .addCase(adminAraclarAracSilme.fulfilled, (state, action) => {
        state.isLoadingAdminAracSilme = false;
        state.adminAraclar = state.adminAraclar.filter((item)=>{
          return item.id !== action.payload.id
        })
      })
      .addCase(adminAraclarAracSilme.rejected, (state) => {
        state.isLoadingAdminAracSilme = false;
      })

      //! get truck doc
      .addCase(adminGetTruckDoc.pending, (state) => {
        state.isLoadingGetDoc = true;
        state.adminTruckDocs = null;
      })

      .addCase(adminGetTruckDoc.fulfilled, (state, action) => {
        state.isLoadingGetDoc = false;
        state.adminTruckDocs = action.payload.data;
      })

      .addCase(adminGetTruckDoc.rejected, (state, action) => {
        state.isLoadingGetDoc = false;
      })

      //! get trailer doc
      .addCase(adminGetTrailerDoc.pending, (state) => {
        state.isLoadingGetDoc = true;
        state.adminTrailerDocs = null;
      })

      .addCase(adminGetTrailerDoc.fulfilled, (state, action) => {
        state.isLoadingGetDoc = false;
        state.adminTrailerDocs = action.payload.data;
      })

      .addCase(adminGetTrailerDoc.rejected, (state, action) => {
        state.isLoadingGetDoc = false;
      })

      //! get web hesap
      .addCase(getWebHesaplama.pending, (state) => {
        state.isLoadingWebSonuclari = true;
      })

      .addCase(getWebHesaplama.fulfilled, (state, action) => {
        state.isLoadingWebSonuclari = false;
        state.webHesaplamaSonuclari = action.payload.data.getAllMaliyetHesabiEntriesQueryResponses.$values;
        state.webHesaplamaSonuclariCount = action.payload.data.count
      })

      .addCase(getWebHesaplama.rejected, (state, action) => {
        state.isLoadingWebSonuclari = false;
      })










//! ****************************************************************************************************************************************


    //! getAdminUyeler
    .addCase(getAdminUyeler.pending, (state) => {
      state.isLoadingGetAdminUyeler = true;
    })

    .addCase(getAdminUyeler.fulfilled, (state, action) => {
      state.isLoadingGetAdminUyeler = false;
      state.adminUyeler = action.payload.data.musteriListesi.$values.map((item) => {
          return {
            ...item,
            ehliyetTypes: item.ehliyetTypes.$values,
            srcTypes: item.srcTypes.$values,
          };
        }
      );
      state.adminUyelerCount = action.payload.data.count;
    })

    .addCase(getAdminUyeler.rejected, (state, action) => {
      state.isLoadingGetAdminUyeler = false;
    })


    //! adminUpdateUyeDoc
    .addCase(adminUpdateUyeDoc.pending, (state) => {
      state.isLoadingUpdateUyeDoc = true
      state.isSuccessUyeDoc = false
    })
    .addCase(adminUpdateUyeDoc.fulfilled, (state, action) => {
      state.isLoadingUpdateUyeDoc = false
      state.uyeItemData = {
        ...action.payload,
        ehliyetTypes: action.payload.ehliyetTypes.$values,
        srcTypes: action.payload.srcTypes.$values
      }
      state.adminUyeler = state.adminUyeler.map(item => {
        if(item.id === action.payload.id){
          return {
            ...action.payload,
            ehliyetTypes: action.payload.ehliyetTypes.$values,
            srcTypes: action.payload.srcTypes.$values,
          }
        }
        else{
          return item
        }
      })
      state.isSuccessUyeDoc = true
    })
    .addCase(adminUpdateUyeDoc.rejected, (state) => {
      state.isLoadingUpdateUyeDoc = false
      state.isSuccessUyeDoc = false
    })

    .addCase(getAllTruckAndTrailer.pending, (state) => {
      state.isLoadingGetAllTruckAndTrailer = true;
    })
    .addCase(getAllTruckAndTrailer.fulfilled, (state, action) => {
      const {data} = action.payload
      state.isLoadingGetAllTruckAndTrailer = false;
      state.adminAraclarCount = data.count
      state.adminAraclar = [
        ...data?.trucks.$values.map(item =>{
        return {...item, type: "truck"}
      }),
      ...data?.trailers.$values.map(item => {
        return {
          ...item, type: "trailer"
        }
      })];
    })
    .addCase(getAllTruckAndTrailer.rejected, (state, action) => {
      state.isLoadingGetAllTruckAndTrailer = false;
    })



      //! adminUpdateDocumentTruck
      .addCase(adminUpdateDocumentTruck.pending, (state) => {
        state.isLoadingAdminUpdateDocumentTruck = true
      })

      .addCase(adminUpdateDocumentTruck.fulfilled, (state, action) => {
        state.isLoadingAdminUpdateDocumentTruck = false
        state.adminAraclar = state.adminAraclar.map(item => {
          if(item.id === action.payload.id){
            return {...action.payload, type: "truck"}
          }
          else{
            return item
          }
        })
        state.selectAdminArac = {...action.payload, type: "truck"}
      })

      .addCase(adminUpdateDocumentTruck.rejected, (state, action) => {
        state.isLoadingAdminUpdateDocumentTruck = false
      })


      //! adminUpdateDocumentTrailer
      .addCase(adminUpdateDocumentTrailer.pending, (state) => {
        state.isLoadingAdminUpdateDocumentTrailer = true

      })

      .addCase(adminUpdateDocumentTrailer.fulfilled, (state, action) => {
        state.isLoadingAdminUpdateDocumentTrailer = false
        state.adminAraclar = state.adminAraclar.map(item => {
          if(item.id === action.payload.id){
            return {...action.payload, type: "trailer"}
          }
          else{
            return item
          }
        })
        state.selectAdminArac = {...action.payload, type: "trailer"}
      })

      .addCase(adminUpdateDocumentTrailer.rejected, (state, action) => {
        state.isLoadingAdminUpdateDocumentTrailer = false

      })

      //! adminAracYetkiBelgesiSorgula
      .addCase(adminAracYetkiBelgesiSorgula.pending, (state) => {
        state.isLoadingAdminAracYetkiBelgesiSorgula = true;
      })
      .addCase(adminAracYetkiBelgesiSorgula.fulfilled, (state, action) => {
        state.isLoadingAdminAracYetkiBelgesiSorgula = false;
        state.yetkiBelgesiBilgi = action.payload.data;
      })
      .addCase(adminAracYetkiBelgesiSorgula.rejected, (state, action) => {
        state.isLoadingAdminAracYetkiBelgesiSorgula = false;
      })

      //! adminAracCezaSorgula
      .addCase(adminAracCezaSorgula.pending, (state) => {
        state.isLoadingAdminAracCezaSorgula = true;
      })
      .addCase(adminAracCezaSorgula.fulfilled, (state, action) => {
        state.isLoadingAdminAracCezaSorgula = false;
        state.cezaBilgi = action.payload;
      })
      .addCase(adminAracCezaSorgula.rejected, (state, action) => {
        state.isLoadingAdminAracCezaSorgula = false;
      })

      //! adminAracMuayeneSorgula
      .addCase(adminAracMuayeneSorgula.pending, (state) => {
        state.isLoadingAdminAracMuayeneSorgula = true;
      })
      .addCase(adminAracMuayeneSorgula.fulfilled, (state, action) => {
        state.isLoadingAdminAracMuayeneSorgula = false;
        state.muayeneBilgi = action.payload.data;
      })
      .addCase(adminAracMuayeneSorgula.rejected, (state) => {
        state.isLoadingAdminAracMuayeneSorgula = false;
      })



      //! removeAdminUserDocItem
      .addCase(removeAdminUserDocItem.pending, (state) => {
      })
      .addCase(removeAdminUserDocItem.fulfilled, (state, action) => {

        state.adminUyeler = state.adminUyeler.map(item => {
          if(item.id === action.payload.id){
            return {...item, [action.payload.message]: null}
          }
          else{
            return item
          }
        })
        state.uyeItemData = {...state.uyeItemData, [action.payload.message]: null}
      })
      .addCase(removeAdminUserDocItem.rejected, (state) => {
      })

      //! removeAdminTruckDocItem
      .addCase(removeAdminTruckDocItem.pending, (state) => {
      })
      .addCase(removeAdminTruckDocItem.fulfilled, (state, action) => {
        state.adminAraclar = state.adminAraclar.map(item => {
          if(item.id === action.payload.id){
            return {...item, [action.payload.message]: null}
          }
          else{
            return item
          }
        })
        state.selectAdminArac = {...state.selectAdminArac, [action.payload.message]: null}

      })
      .addCase(removeAdminTruckDocItem.rejected, (state) => {
      })

      //! removeAdminTrailerDocItem
      .addCase(removeAdminTrailerDocItem.pending, (state) => {
      })
      .addCase(removeAdminTrailerDocItem.fulfilled, (state, action) => {
        state.adminAraclar = state.adminAraclar.map(item => {
          if(item.id === action.payload.id){
            return {...item, [action.payload.message]: null}
          }
          else{
            return item
          }
        })
        state.selectAdminArac = {...state.selectAdminArac, [action.payload.message]: null}

      })
      .addCase(removeAdminTrailerDocItem.rejected, (state) => {
      })


  },
});


export const { setTopluAracEklemeHatalar, getUyeItemData, setSelectAdminArac, clearTopluUyeEkleMessageList, setTopluUyeEkleMessageList } = admin2Slice.actions;
export default admin2Slice.reducer;
